import { render, staticRenderFns } from "./DayColumn.vue?vue&type=template&id=5936c95b&scoped=true"
import script from "./DayColumn.vue?vue&type=script&lang=js"
export * from "./DayColumn.vue?vue&type=script&lang=js"
import style0 from "./DayColumn.vue?vue&type=style&index=0&id=5936c95b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936c95b",
  null
  
)

export default component.exports